<template>
    <div class="tools-tab tools-tab-notes">
        <icon name="info" v-tooltip="$t('tooltip.roster.tools.notes')" />
        <textarea v-model="notes" :placeholder="$t('tooltip.roster.tools.notes')" maxlength="500" @keydown="handleKeys" @focus="focus"></textarea>

        <a href="#" class="remove btn btn--red" v-on:click.prevent="remove()" v-if="item.notes">{{ $t('common.button.delete') }}</a>
        <a href="#" class="btn btn--green" v-on:click.prevent="save()">{{ $t('common.button.save') }}</a>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';
import { mapState } from 'vuex';

export default
{
    name: 'Notes',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
            notes: '',
        }
    },

    computed:
    {
        ...mapState({
            android: ({ app }) => app.os === 'android'
        })
    },

    created()
    {
        this.notes = this.item.notes;
    },

    methods:
    {
        save(remove)
        {
            let notes = remove ? '' : this.notes;

            this.$http.put(
            '/api/items/' + this.item.id + '/notes', {
                notes: notes // be explicit :)
            })
            .then(response =>
            {
                // update item and local property
                this.item.notes = notes;
                this.notes = notes;

                this.$tools.close();
            });
        },

        remove()
        {
            this.save(true); // remove
        },

        handleKeys(e)
        {
            // no CTRL or CMD key pressed
            if ( ! (e.metaKey || e.ctrlKey)) return;

            let key = e.which || e.keyCode || 0;

            // select all (CTRL+A)
            if (key == 65)
            {
                // prevent roster items from being selected
                e.stopPropagation();
            }
        },

        focus()
        {
            if (this.android) events.$emit('input.focus', true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Notes.vue?9698a2c8